import { Component, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { MmuMaintenanceNotice } from '../mmu-maintenance-service/mmu-maintenance-notice';
import { MmuMaintenanceService } from '../mmu-maintenance-service/mmu-maintenance.service';


@Component({
  selector: 'mmu-maintenance-banner',
  template: `
    <mui-banner
      *ngFor="let notice of (notices$ | async)"
      [icon]="notice.icon"
      [color]="notice.color ?? 'info'"
      [dismissButtonLabel]="'unsupportedBrowserBanner.closeBtn' | translate"
      (dismiss)="dismiss(notice)"
      class="mui-app-frame__banner banner--maintenance">
      <span [innerHTML]="getTextContent(notice)"></span>
    </mui-banner>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .banner--maintenance ::ng-deep a {
        color: inherit;
        cursor: pointer;
        font-weight: 500;
        text-decoration: underline;
      }
    `
  ]
})
export class MmuMaintenanceBannerComponent {
  readonly notices$: Observable<MmuMaintenanceNotice[]>;

  constructor(
    private maintenanceService: MmuMaintenanceService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    this.notices$ = this.maintenanceService.getNotices();
  }

  getTextContent(notice: MmuMaintenanceNotice): string {
    const currentLang = this.translate.currentLang;
    const content = notice.translations[currentLang]
      || notice.translations[currentLang?.slice(0, 2)]
      || notice.translations['en-US']
      || notice.translations['en'];
    const contentText = typeof content === 'string' ? content : content.content;
    return this.sanitizer.sanitize(SecurityContext.HTML, contentText) ?? '';
  }

  dismiss(notice: MmuMaintenanceNotice): void {
    this.maintenanceService.closeNotice(notice);
  }

}
